import { SvgIcon, type SvgIconProps } from "@mui/material";
import React from "react";

interface CheckboxIconProps extends SvgIconProps {
  checked?: boolean;
}

export const CheckboxIcon = (props: CheckboxIconProps) => {
  const { checked = false, ...svgProps } = props;
  return (
    <SvgIcon viewBox="0 0 20 20" {...svgProps}>
      {checked ? (
        <path
          id="icon_tick"
          data-name="icon tick"
          d="M400.34,932h-8.67c-3.391,0-5.67-2.375-5.67-5.909V917.92c0-3.541,2.279-5.92,5.67-5.92h8.67c3.385,0,5.66,2.379,5.66,5.92v8.171C406,929.625,403.725,932,400.34,932Zm-7.9-10.875a.875.875,0,0,0-.62,1.5l2.38,2.365a.881.881,0,0,0,1.23,0l4.75-4.75a.877.877,0,0,0-1.24-1.24l-4.13,4.13-1.75-1.75A.867.867,0,0,0,392.44,921.125Z"
          transform="translate(-386 -912)"
          fill="#00b4d8"
        />
      ) : (
        <g
          id="check_box"
          data-name="check box"
          fill="#fff"
          stroke="#c0bdcc"
          strokeWidth="1"
        >
          <rect width="20" height="20" rx="6" stroke="none" />
          <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" fill="none" />
        </g>
      )}
    </SvgIcon>
  );
};